import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=7f21ef6f&scoped=true"
import script from "./Page404.vue?vue&type=script&lang=ts"
export * from "./Page404.vue?vue&type=script&lang=ts"
import style0 from "./Page404.vue?vue&type=style&index=0&id=7f21ef6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21ef6f",
  null
  
)

export default component.exports